<template>
  <div class="pb-5 acc_list_main" :class="{'map-visible': showMap}">


    <div class="p_list_map mt-5 mt-md-0" :class="{'d-none': !showMap}">
      <ClientOnly>
        <component :is="RightMapComponent" v-if="RightMapComponent && showMap" ref="mapRef"
                   @onBoundsChange="onBoundsChange" @onCenterChange="onCenterChange"
                   :mapObjects="mapObjects" :activeLocale="activeLocale" :activeCountry="activeCountry"/>
      </ClientOnly>
      <div class="tempMapImage" v-if="!firstLoad && showMap">
        <div class="imgContent"
             :style="{backgroundImage: `url(/img/map_background.webp)`}"></div>
      </div>
    </div>

    <div :class="showMap ? '' : 'container'" class="p_list_content">
      <div class=" mt-5 mt-md-3 mt-lg-0">

        <div class="header mb-4">

          <div class="left d-none d-md-flex">
            <p class="h5 d-block mb-0" v-if="totalCount > 0">
              {{ totalCount > 50 ? '50+' : totalCount }}&nbsp;{{
                $t($vysklonujSlovo('ubytovanie', totalCount, 'ia', 'i'))
              }}
            </p>
            <p class="h5 mb-3" v-else-if="loading === false">
              {{ $t('ziadne-ubytovanie') }}
            </p>
            <p class="h5 mb-3" v-else-if="loading">
              {{ $t('loading') }}
            </p>
          </div>
          <div class="right">

            <button class="btn btn-outline-first btn-filter rounded" @click="filterOpen = !filterOpen">
              <TyIcon icon="ty-settings-3" width="1rem" height="1rem" class="me-2"/>
              <span>{{ $t('Filter') }}<span class="filter-count" v-if="filterActiveCount > 0">({{ filterActiveCount }})</span>
              </span>
            </button>

            <button class="btn btn-outline-first btn-map rounded" @click="toggleMapVisibility">
              <TyIcon icon="ty-map-pointer" width="1rem" height="1rem" class="me-2"/>
              <span>{{ $t('map') }}</span>
            </button>

          </div>
        </div>

        <TempPageObjects :accommodations="content" v-if="firstLoad === false" :activeLocale="activeLocale"
                         :cardClass="showMap ? '' : 'col-12 col-md-4 col-lg-3'"/>
        <template v-else-if="accommodations.length === 0 && !loading">
          <div class="alert alert-info mt-5 mx-2">
            {{ $t('no-accommodation-found') }}
          </div>
        </template>
        <template v-else-if="totalCount > 0">
          <div class="list_items acc_list_1_3 mb-5 mb-lg-0 row px-0" ref="listItems">
            <div v-for="accommodation in accommodations" :class="showMap ? 'col-12' : 'col-12 col-md-4 col-lg-3'"
                 :key="'acc_item_' + accommodation.id">
              <ListItem :accommodation="accommodation" :activeLocale="activeLocale" :activeCountry="activeCountry"
                        :params="useRoute().query" :client="client" v-if="showMap" :currency="activeLocaleCurrency"
                        :widgetName="widgetData.title" :GATrackEvent="GATrackEvent"/>
              <ListItemNoMap :accommodation="accommodation" :activeLocale="activeLocale" :activeCountry="activeCountry"
                             :params="useRoute().query" :client="client" v-else :currency="activeLocaleCurrency"
                             :widgetName="widgetData.title" :GATrackEvent="GATrackEvent"/>
            </div>
          </div>
        </template>
        <nav aria-label="page navigation" v-if="totalCount > 0 && accommodations.length < totalCount"
             class="w-100 text-center">
          <button class="btn btn-outline-first btn-rounded" @click="loadAccommodations(false)">
            {{ $t('load-next') }}
          </button>
          <ul class="pagination justify-content-center d-none">
            <li class="page-item pointer">
              <a class="page-link left">
                <TyIcon icon="ty-arrow-left-chevron" width="1.2rem"/>
              </a>
            </li>
            <li class="page-item"><a class="page-link" href="#">1</a></li>
            <li class="page-item"><a class="page-link" href="#">2</a></li>
            <li class="page-item"><a class="page-link" href="#">3</a></li>
            <li class="page-item">
              <a class="page-link right">
                <TyIcon icon="ty-arrow-right-chevron" width="1.2rem"/>
              </a>
            </li>

          </ul>
        </nav>
      </div>

      <PartsTempPreloader v-if="loading" :class="'top-40'"/>
    </div>

    <BModal :open="filterOpen" centered size="lg"
            modal-class="default-backdrop acc_list_main-modal"
            @hide="filterOpen = false">
      <div class="hch_modal-content">
        <HCHModalHeader :close="() => filterOpen = false"/>
        <div class="hch_modal-body px-lg-4">
          <LazyWidgetAccommodationListAccListMainFilter ref="additionalFilter"
                                                        :currency="activeLocaleCurrency.code"
                                                        :activeLocale="activeLocale"
                                                        :defaultFilterParams="validateFilterParams(clearObserverObj(filterParams))"
                                                        :open="filterOpen"/>
        </div>

        <div class="hch_modal-footer">

          <button class="btn btn-outline-danger btn-rounded p-3 px-4 fw-semibold" @click="resetFilter">
            {{ $t('reset-filter') }}
          </button>

          <button class="btn btn-first btn-block btn-rounded p-3 px-4 fw-semibold" @click="useFilter">
            {{ $t('show-result') }}
            {{ totalFilterOptionsCount > 0 ? `${totalFilterOptionsCount}` : '' }}
            {{ $t($vysklonujSlovo('offer', 'u', 's')) }}
          </button>

        </div>
      </div>
    </BModal>

  </div>
</template>

<script setup lang="ts">
import "@/assets/less/acc_list_main.min.css";
import "@/assets/less/acc_list_1_3.min.css";
import TempPageObjects from "./acc_list_main/temp_page_objects.vue";
import Accommodation from "../../../../lib/models/Accommodation";
import ListItem from "./acc_list_main/acc_list_main_accommodation_item";
import ListItemNoMap from "./acc_list_1_3/item.vue";
import {buildUrlFromParams, clearObserverObj, getDistance, parseCurrentURL} from "../../../../lib/functions";
import {computed, defineAsyncComponent, onMounted, PropType, ref, shallowRef} from "vue";
import {PageDataHolderFetchedWidget} from "../../../../lib/interfaces/model/PageDataHolderFetchedWidget";
import {useWidget} from "../../../../composables/widget/accommodation_list";
import {useNuxtApp, useRoute} from "#app";
import useStateAccommodationList from "../../../../composables/state/accommodation_list";
import {GATracker} from "../../../../composables/ga_tracker";
import BModal from "../../parts/b-modal.vue";
import HCHModalHeader from "../../parts/modals/hch_modal_header.vue";

const props = defineProps({
  widget: Object as PropType<PageDataHolderFetchedWidget>
});

const {widgetData, content, activeLocale, activeCountry, activeLocaleCurrency, client} = useWidget(props.widget);
const {$tyrionApi, $isDesktop, $vysklonujSlovo} = useNuxtApp();

const RightMapComponent = shallowRef(null);
const {GATrackEvent} = GATracker();

if (process.client) {
  RightMapComponent.value = defineAsyncComponent(() => import("./acc_list_main/acc_list_main_map.vue"));
}

const accommodations = ref<Array<Accommodation>>([]);
const mapObjects = ref<Array<{ latitude: number, longitude: number, id: number }>>([]);
const firstLoad = ref<boolean>(false);
const totalCount = ref<number>(-1);
const limit = 24;
const pager = ref<number>(1);
const locationLoaded = ref(false);
const loading = ref(false);
const showMap = ref(false);
const filterOpen = ref(false);
const searchingTimeout = ref<number | null>(null);
const loadingAccommodationTimeout = ref<null | number>(null);
const changeMapUrlTimeout = ref<number | null>(null);
const mapRef = ref(null);
const additionalFilter = ref(null);
const filterParams = ref<{ [k: string]: string | number | Array<{}> }>({});
const baseFilterLocation = ref<{ [k: string]: any }>({});

const isPhoneDevice = computed(() => {
  return !$isDesktop();
});
const totalFilterOptionsCount = computed(() => {
  return additionalFilter.value ? additionalFilter.value.obtainTotalItemsCount : 0;
});
const filterActiveCount = computed(() => {
  let totalCount = 0;
  if (Array.isArray(filterParams.value.properties) && filterParams.value.properties.length > 0) {
    totalCount += filterParams.value.properties.length;
  }
  if (Array.isArray(filterParams.value.type) && filterParams.value.type.length > 0) {
    totalCount += filterParams.value.type.length;
  }
  if (filterParams.value.price) {
    totalCount += 1;
  }
  return totalCount;
});
const {setLastFilterData} = useStateAccommodationList();

filterParams.value = parseCurrentURL(useRoute().fullPath) as { [k: string]: string | number | Array<{}> };
showMap.value = Number(filterParams.value.map_visible) === 1;

const obtainLocation = () => {
  loading.value = true;
  if (!filterParams.value.places || filterParams.value.places.length === 0 || !Array.isArray(filterParams.value.places)) {
    return new Promise((resolve, reject) => {
      reject()
    });
  }
  return $tyrionApi.postTyrionUrl('/api3/places/obtainLocationPosition', {
    body: {
      path: useRoute().path,
      place: filterParams.value.places.map(p => {
        return {
          type: p.type,
          id: p.id,
          query_position: {
            latitude: p.map_lat,
            longitude: p.map_lon,
            zoom: p.map_zoom,
          }
        }
      })
    }
  }).then(res => {
    if (res.status === 'success') {

      const tInt = setInterval(() => {
        if (mapRef.value !== null && mapRef.value.loaded === true) {
          let zoom = res.data.zoom as Number;
          if (zoom > 0 && isPhoneDevice.value) {
            switch (res.data.type) {
              case "tourist_region":
                zoom = Number(zoom) - 1.3;
                break;
              case "district":
                zoom = Number(zoom) - 1.5;
                break;
              case "city":
                zoom = Number(zoom) - 1.5;
                break;
            }
          }
          mapRef.value.updateMapLocation(res.data.latLng, zoom);
          locationLoaded.value = true;
          loading.value = false;
          clearInterval(tInt);
        }
      }, 300);
    } else {
      loading.value = false;
    }


    return res.data;
  }).catch(() => {
    loading.value = false;
  });

}

onMounted(() => {
    loadAccommodations(true);
});

const onBoundsChange = (mapBounds) => {
  filterParams.value.location_bounds = mapBounds;
  if (searchingTimeout.value !== null) clearTimeout(searchingTimeout.value);
  searchingTimeout.value = setTimeout(() => {
    loadAccommodations(true);
  }, 300);
}

const validateFilterParams = (params: { [k: string]: string | number | Array<{}> }): {
  [k: string]: string | number
} => {
  const allowedParams = ['p_adult', 'p_child', 'p_newborn', 'location_bounds', 'dateFrom', 'dateTo', 'places', 'p_room', 'properties', 'type', 'price', 'order_by'];
  Object.keys(params).forEach((key) => {
    if (!allowedParams.includes(key)) {
      delete params[key];
    }
  });
  setLastFilterData(params);
  if (!showMap.value) {
    delete params.location_bounds;
  }
  return params;
};

const onCenterChange = (mapLocation) => {
  if (changeMapUrlTimeout.value !== null) clearTimeout(changeMapUrlTimeout.value);
  changeMapUrlTimeout.value = setTimeout(() => {
    if (baseFilterLocation.value && baseFilterLocation.value.latLng) {
      const distance = getDistance([baseFilterLocation.value.latLng.latitude, baseFilterLocation.value.latLng.longitude], [mapLocation.lat, mapLocation.lng]);
      if (distance < 1500 &&
          (Math.round(mapLocation.zoom) === Math.round(baseFilterLocation.value.zoom))
      ) {
        changeMapUrlTimeout.value = null;
        return;
      }
    }
    const paramsString = window.location.search
    const searchParams = new URLSearchParams(paramsString);
    searchParams.set('map_lat', mapLocation.lat);
    searchParams.set('map_lon', mapLocation.lng);
    searchParams.set('map_zoom', mapLocation.zoom);
    searchParams.set('pl_type', 'coordinated');
    searchParams.set('pl_id', '-1');
    const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
    window.history.replaceState({path: newurl}, '', newurl);
    changeMapUrlTimeout.value = null;
  }, 500);
};


const loadAccommodations = (firstPage = true) => {

  loading.value = true;
  if (loadingAccommodationTimeout.value !== null) clearTimeout(loadingAccommodationTimeout.value);

  loadingAccommodationTimeout.value = setTimeout(() => {
    const params = clearObserverObj(filterParams.value);
    if (firstPage) {
      pager.value = 1;
    } else {
      GATrackEvent({
        event: 'load_more_accommodations',
        language: activeLocale.code,
        action: 'click',
        label: 'Load more accomodations',
        widget: widgetData.title,
      });
    }

    $tyrionApi.postTyrionUrl('/api3/accommodation/filter', {
      body: {
        currency: activeLocaleCurrency.code,
        filter: validateFilterParams(params),
        limit: limit,
        page: pager.value
      }
    }).then(res => {
      if (res.status === 'success') {
        totalCount.value = res.data.count;

        mapObjects.value = res.data.mapObjects.map(acc => {
          return {latitude: acc.latitude, longitude: acc.longitude, id: acc.id};
        })
        const accs = res.data.objects.map(i => {
          return (new Accommodation()).fromObject(i) as Accommodation;
        });

        accommodations.value = firstPage ? accs : [].concat(accommodations.value, accs);

        pager.value++;
        setTimeout(() => {
          firstLoad.value = true;
          loading.value = false;
        }, 400)
      } else {
        if (firstPage) {
          accommodations.value = [];
        }
        mapObjects.value = [];
        firstLoad.value = true;
        loading.value = false;
        alert(res.message);
      }

    })
  }, 400)

}

const useFilter = () => {
  const additionalFilterData = additionalFilter.value.getFilterData();
  filterParams.value = {...filterParams.value, ...additionalFilterData};
  const newUrl = buildUrlFromParams(filterParams.value);

  const newRelativePathQuery = window.location.pathname + newUrl;
  history.pushState(null, '', newRelativePathQuery);
  filterOpen.value = false;
  loadAccommodations(true);
};

const resetFilter = () => {

  delete filterParams.value.price;
  delete filterParams.value.properties;
  delete filterParams.value.type;
  const newUrl = buildUrlFromParams(filterParams.value);

  const newRelativePathQuery = window.location.pathname + newUrl;
  filterOpen.value = false;
  loading.value = true;
  setTimeout(() => {
    window.location.href = newRelativePathQuery;
  }, 200);
};

const toggleMapVisibility = () => {
  showMap.value = !showMap.value;

  const url = new URL(window.location.href);
  url.searchParams.set('map_visible', String(Number(showMap.value)));
  window.history.pushState(null, '', url.toString());

  if (showMap.value === false) {
    loadAccommodations(true);
  }
};


obtainLocation().then((res) => {
  baseFilterLocation.value = res;
}).catch(e => {
  console.log(e);
});
</script>
